import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import Axios from 'axios';

import { passwordValidator } from '../../utils/helpers/index';
import {
    TITLES,
    GENDERS,
    PREFERRED_PHONE_COUNTRIES,
    REFERRAL_SOURCES_TYPE,
    CUSTOMER_DEFAULT_FIELDS_FOR_CUSTOMER_APP
} from '../../collums-constants/index';
import { complete_fields, existing_customer_email } from '../../constants/messages';
import { loginModalStyles } from './styles';

import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    makeStyles,
    TextField,
    Typography,
    CircularProgress,
    Checkbox,
    InputLabel,
    OutlinedInput,
    InputAdornment,
    IconButton,
    Select,
    MenuItem
} from '@material-ui/core';
import { KeyboardDatePicker } from '@material-ui/pickers';
import { ArrowBackIos } from '@material-ui/icons';

import AuthApi from '../../api/authApi';

import { authUser, changeModalVisibility } from '../../redux/actions/auth';
import PhoneNumberInput from 'material-ui-phone-number';
import { isValidPhone } from '../../collums-components/helpers/validPhoneNumber';
import { getOrganisationCountryCode } from '../../collums-components/helpers';
import SimpleCountriesInput from '../../collums-components/form/SimpleCountriesInput';
import Moment from 'moment';
import ListApi from '../../collums-components/api/ListApi';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const titles = [TITLES.MRS, TITLES.MISS, TITLES.MS, TITLES.MR, TITLES.MX, TITLES.DR];
const genders = [GENDERS.MALE, GENDERS.FEMALE, GENDERS.TRANS_MALE, GENDERS.TRANS_FEMALE];
const signupMethodsConstant = {
    EXISTING_CUSTOMER: 'EXISTING_CUSTOMER',
    FIRST_TIME: 'FIRST_TIME'
};

const LoginModal = ({ setOpenInfoModal, setInfoText }) => {
    const modalVisibility = useSelector(state => state.auth.loginModalVisible);
    const organisation = useSelector(state => state.auth.organisation);

    const customerDefaultFields =
        organisation.customerFieldsForCustomerApp && organisation.customerFieldsForCustomerApp.length
            ? organisation.customerFieldsForCustomerApp
            : CUSTOMER_DEFAULT_FIELDS_FOR_CUSTOMER_APP;

    const dispatch = useDispatch();
    const [form, setForm] = useState({});
    const [isLogin, setIsLogin] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [accountCreated, setAccountCreated] = useState(false);
    const [referralSourceType, setReferralSourceType] = useState(Object.values(REFERRAL_SOURCES_TYPE).sort());
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [displayInfo, setDisplayInfo] = useState({
        canDisplay: false,
        text: '',
        displayRed: false
    });

    const [isInvalid, setIsInvalid] = useState({
        otherPhone: false,
        phone: false
    });

    useEffect(() => {
        ListApi.getAll().then(lists => {
            const referralSource = lists.find(el => el.sys_name === 'client_referral_sources');
            if (referralSource) {
                setReferralSourceType(referralSource.values.split('\n'));
            }
        });
        //eslint-disable-next-line
    }, []);

    const [signupMethod, setSignupMethod] = useState(false);

    const currentStepState = useSelector(state => state.bookAppointment);
    const history = useHistory();

    const classes = makeStyles(loginModalStyles)();

    async function handleLogin(e) {
        e.preventDefault();
        setAccountCreated(false);
        if (isLogin) {
            setIsLoading(true);
            const authData = {
                email: (form.email || '').toLowerCase(),
                password: form.password
            };
            const response = await AuthApi.auth(authData);

            if (!response.user) {
                setDisplayInfo({
                    canDisplay: true,
                    text: response.message,
                    displayRed: true
                });
                setIsLoading(false);
                return;
            }

            const { token } = response;
            localStorage.setItem('token', token);
            Axios.defaults.headers.common['Authorization'] = token;
            try {
                const user = await AuthApi.getMe();
                dispatch(authUser(user));
                dispatch(changeModalVisibility({ visible: false }));
                setIsLoading(false);
                if (currentStepState.currentStep === 'service') history.replace('/app');
                if (user?.blockOnlineBooking && currentStepState.currentStep === 'confirm') {
                    const giftVouchers = currentStepState.currentGiftVouchers || [];
                    const appointments = currentStepState.currentAppointments || [];
                    const isCourseOnly = appointments.length && appointments.every(app => app?.service?.salePrice);
                    if (!giftVouchers.length && !isCourseOnly) {
                        history.replace('/app', { showBlockedDialog: true });
                    }
                }
            } catch (err) {
                console.error(err);
            }
        } else {
            setDisplayInfo({
                canDisplay: false,
                text: '',
                displayRed: false
            });
            setForm({});
            setIsLogin(true);
        }
    }

    function handleClose() {
        setDisplayInfo({
            canDisplay: false,
            text: '',
            displayRed: false
        });
        setForm({});
        setIsLogin(true);
        dispatch(changeModalVisibility({ visible: false }));
    }

    const getCountryCode = () => {
        return getOrganisationCountryCode({
            ...organisation,
            address: {
                country: organisation?.country || undefined
            }
        });
    };

    async function handleRegister(e) {
        e.preventDefault();
        setAccountCreated(false);
        if (!isLogin) {
            if (signupMethod === signupMethodsConstant.FIRST_TIME) {
                let currentEl = customerDefaultFields.find(el => el.name === 'title');
                if (form.title && currentEl.required && !titles.includes(form.title)) {
                    setDisplayInfo({ canDisplay: true, text: 'Invalid Title', displayRed: true });
                    return;
                }
                if (!form.name) {
                    setDisplayInfo({ canDisplay: true, text: 'Name is required', displayRed: true });
                    return;
                }
                if (!form.surname) {
                    setDisplayInfo({ canDisplay: true, text: 'Surname is required', displayRed: true });
                    return;
                }
                if (isInvalid.phone) {
                    setDisplayInfo({ canDisplay: true, text: 'Phone number is invalid', displayRed: true });
                    return;
                }
                currentEl = customerDefaultFields.find(el => el.name === 'dateOfBirth');
                if (!form.dob && currentEl.required) {
                    setDisplayInfo({ canDisplay: true, text: 'Date of birth is required', displayRed: true });
                    return;
                }
                currentEl = customerDefaultFields.find(el => el.name === 'gender');
                if (!genders.includes(form.gender) && currentEl.required) {
                    setDisplayInfo({ canDisplay: true, text: 'Gender is required', displayRed: true });
                    return;
                }
                currentEl = customerDefaultFields.find(el => el.name === 'mobilePhone');
                if (!form.mobile && currentEl.required) {
                    setDisplayInfo({ canDisplay: true, text: 'Mobile is required', displayRed: true });
                    return;
                }
                currentEl = customerDefaultFields.find(el => el.name === 'referralSource');
                if (!form.referralSource && currentEl.required) {
                    setDisplayInfo({
                        canDisplay: true,
                        text: 'How did you hear about us is required',
                        displayRed: true
                    });
                    return;
                }
                if (!form.email) {
                    setDisplayInfo({ canDisplay: true, text: 'Email is required', displayRed: true });
                    return;
                }
            }

            if (signupMethod === signupMethodsConstant.EXISTING_CUSTOMER) {
                const response = await AuthApi.forgotPassword((form.email || '').toLowerCase(), true);
                if (response.statusCode === 400) {
                    setDisplayInfo({ canDisplay: true, text: response.message, displayRed: true });
                    setForm({});
                    return;
                }
                if (response) {
                    setDisplayInfo({ canDisplay: true, text: existing_customer_email, displayRed: false });
                    setInfoText('sign_up_existing_customer_email');
                    dispatch(changeModalVisibility({ visible: false }));
                    setOpenInfoModal(true);
                    setForm({});
                }
                return;
            }

            if (!new RegExp(passwordValidator).test(form.password)) {
                setDisplayInfo({
                    canDisplay: true,
                    text: 'Password must have at least 8 characters, one capital letter and one number',
                    displayRed: true
                });
                return;
            }

            if (form.password !== form.confirmPassword) {
                setDisplayInfo({ canDisplay: true, text: 'Passwords do not match', displayRed: true });
                return;
            }

            const response = await AuthApi.register({
                title: form.title,
                name: (form.name || '').trim(),
                surname: (form.surname || '').trim(),
                dob: form.dob,
                gender: form.gender,
                email: (form.email || '').toLowerCase(),
                mobile: form.mobile,
                password: form.password,
                referralSource: form.referralSource,
                address1: form.address1,
                address2: form.address2,
                city: form.city,
                county: form.county,
                country: form.country,
                postal: form.postal
            });
            if (response.statusCode === 400) {
                setDisplayInfo({ canDisplay: true, text: response.message, displayRed: true });
                return;
            }

            setDisplayInfo({ canDisplay: false, text: '', displayRed: false });
            setInfoText('sign_up_new_customer_email');
            dispatch(changeModalVisibility({ visible: false }));
            setOpenInfoModal(true);
            setAccountCreated(true);
            setForm({});
            setIsLogin(true);
            setSignupMethod(undefined);
        } else {
            setDisplayInfo({ canDisplay: false, text: '', displayRed: false });
            setForm({});
            setIsLogin(false);
            setSignupMethod('sing up');
        }
    }

    const signupForm = () => {
        if (!signupMethod) return checkboxes();
        const title = (() => {
            if (signupMethod === signupMethodsConstant.EXISTING_CUSTOMER) {
                return (
                    <>
                        Enter the email address that we use to contact you and click &quot;Sign Up&quot; <br />
                        The system will look for a match and, if found, connect you to your account.
                        <br />
                        If your email is not matched in our system, you will not receive an email.
                    </>
                );
            } else if (signupMethod === signupMethodsConstant.FIRST_TIME) {
                return complete_fields;
            } else return '';
        })();

        return (
            <div style={{ marginBottom: '25px' }}>
                {checkboxes()}
                <Typography className={classes.singupTitle}>
                    <br />
                    {title}
                </Typography>
                {signupMethod === signupMethodsConstant.EXISTING_CUSTOMER && (
                    <form onSubmit={handleRegister} autoComplete="on">
                        <TextField
                            value={form.email || ''}
                            onChange={event => setForm({ ...form, email: event.target.value })}
                            fullWidth
                            className={classes.inputMargin}
                            variant="outlined"
                            label="Email"
                            type="email"
                            name="email"
                            autoComplete="email"
                        />
                        <Box mt={4} display="flex" justifyContent="center">
                            <Button type="submit" className={[classes.button, classes.pinkButton]}>
                                {isLoading ? 'Loading...' : 'Sign Up'}
                            </Button>
                        </Box>
                    </form>
                )}
                {signupMethod === signupMethodsConstant.FIRST_TIME && (
                    <form onSubmit={handleRegister} autoComplete="on">
                        {customerDefaultFields.map(field => {
                            if (!field.show) {
                                return '';
                            }
                            switch (field.name) {
                                case 'title':
                                    return (
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            className={classes.inputMargin}
                                            required={field.required}
                                        >
                                            <InputLabel id="title-label">Title</InputLabel>
                                            <Select
                                                labelId="title-label"
                                                id="title"
                                                value={form.title || ''}
                                                onChange={e => setForm({ ...form, title: e.target.value })}
                                                label="Title"
                                                className={classes.select}
                                            >
                                                {titles.map((option, index) => (
                                                    <MenuItem key={index} value={option} style={{ fontSize: 16 }}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    );
                                case 'firstName':
                                    return (
                                        <TextField
                                            required={field.required}
                                            value={form.name || ''}
                                            onChange={event => setForm({ ...form, name: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="First name"
                                            type="text"
                                            name="name"
                                        />
                                    );
                                case 'surname':
                                    return (
                                        <TextField
                                            required={field.required}
                                            value={form.surname || ''}
                                            onChange={event => setForm({ ...form, surname: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="Last name"
                                            type="text"
                                            name="surname"
                                        />
                                    );
                                case 'dateOfBirth':
                                    return (
                                        <KeyboardDatePicker
                                            inputVariant="outlined"
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            required={field.required}
                                            value={form.dob || null}
                                            label="Dob"
                                            format="dd/MM/yyyy"
                                            placeholder="dd/mm/yyyy"
                                            onChange={event => {
                                                if (!event) return;
                                                const date = Moment(event).format('YYYY-MM-DD') + 'T12:00:00.00Z';
                                                setForm({ ...form, dob: date });
                                            }}
                                        />
                                    );
                                case 'gender':
                                    return (
                                        <FormControl
                                            fullWidth
                                            required={field.required}
                                            variant="outlined"
                                            className={classes.inputMargin}
                                        >
                                            <InputLabel id="gender-label">Gender</InputLabel>
                                            <Select
                                                labelId="gender-label"
                                                id="gender"
                                                value={form.gender || ''}
                                                onChange={e => setForm({ ...form, gender: e.target.value })}
                                                label="Gender"
                                                className={classes.select}
                                            >
                                                {genders.map((option, index) => (
                                                    <MenuItem key={index} value={option} style={{ fontSize: 16 }}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    );
                                case 'mobilePhone':
                                    return (
                                        <PhoneNumberInput
                                            fullWidth
                                            required={field.required}
                                            variant="outlined"
                                            value={form.mobile || ''}
                                            label="Mobile"
                                            enableLongNumbers={true}
                                            inputClass={`${classes.inputMargin} ${classes.input}`}
                                            onChange={(mobile, phoneInfo) => {
                                                setIsInvalid({
                                                    ...isInvalid,
                                                    phone: !isValidPhone(
                                                        mobile,
                                                        phoneInfo.countryCode,
                                                        phoneInfo.dialCode
                                                    )
                                                });
                                                setForm({ ...form, mobile });
                                            }}
                                            error={isInvalid.phone}
                                            preferredCountries={PREFERRED_PHONE_COUNTRIES}
                                            defaultCountry={getCountryCode()}
                                        />
                                    );
                                case 'email':
                                    return (
                                        <>
                                            <TextField
                                                required={field.required}
                                                value={form.email || ''}
                                                onChange={event => setForm({ ...form, email: event.target.value })}
                                                fullWidth
                                                className={`${classes.inputMargin} ${classes.input}`}
                                                variant="outlined"
                                                label="Email"
                                                type="email"
                                                name="email"
                                                autoComplete="email"
                                            />

                                            <FormControl fullWidth>
                                                <TextField
                                                    required
                                                    value={form.password || ''}
                                                    onChange={event =>
                                                        setForm({ ...form, password: event.target.value })
                                                    }
                                                    className={`${classes.inputMargin} ${classes.input}`}
                                                    fullWidth
                                                    error={
                                                        form.password &&
                                                        !new RegExp(passwordValidator).test(form.password)
                                                    }
                                                    variant="outlined"
                                                    label="Password"
                                                    type={showPassword ? 'text' : 'password'}
                                                    name="password"
                                                    autoComplete="new-password"
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={() => setShowPassword(prev => !prev)}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? <Visibility /> : <VisibilityOff />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                                {form.password &&
                                                    !new RegExp(passwordValidator).test(form.password) && (
                                                        <FormHelperText id="component-error-text">
                                                            Password must have at least 8 characters, one capital letter
                                                            and one number.
                                                        </FormHelperText>
                                                    )}
                                            </FormControl>
                                            <TextField
                                                required
                                                value={form.confirmPassword}
                                                onChange={event =>
                                                    setForm({ ...form, confirmPassword: event.target.value })
                                                }
                                                className={`${classes.inputMargin} ${classes.input}`}
                                                fullWidth
                                                variant="outlined"
                                                label="Confirm Password"
                                                type={showPasswordConfirm ? 'text' : 'password'}
                                                name="confirm-password"
                                                autoComplete="new-password"
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                onClick={() => setShowPasswordConfirm(prev => !prev)}
                                                                edge="end"
                                                            >
                                                                {showPasswordConfirm ? (
                                                                    <Visibility />
                                                                ) : (
                                                                    <VisibilityOff />
                                                                )}
                                                            </IconButton>
                                                        </InputAdornment>
                                                    )
                                                }}
                                            />
                                        </>
                                    );
                                case 'referralSource':
                                    return (
                                        <FormControl
                                            fullWidth
                                            variant="outlined"
                                            className={`${classes.inputMargin} ${classes.input} ${classes.textFieldReferralSource}`}
                                            required={field.required}
                                        >
                                            <InputLabel id="referral-source-label">
                                                How did you hear about us?
                                            </InputLabel>
                                            <Select
                                                labelId="referral-source-label"
                                                id="referral-source"
                                                value={form.referralSource || ''}
                                                onChange={e => setForm({ ...form, referralSource: e.target.value })}
                                                label="How did you hear about us?"
                                                className={classes.select}
                                            >
                                                {referralSourceType.map((option, index) => (
                                                    <MenuItem key={index} value={option} style={{ fontSize: 16 }}>
                                                        {option}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    );
                                case 'address1':
                                    return (
                                        <TextField
                                            key={field.name}
                                            required={field.required}
                                            value={form.address1 || ''}
                                            onChange={event => setForm({ ...form, address1: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="Address line 1"
                                            type="text"
                                            name="address1"
                                        />
                                    );
                                case 'address2':
                                    return (
                                        <TextField
                                            key={field.name}
                                            required={field.required}
                                            value={form.address2 || ''}
                                            onChange={event => setForm({ ...form, address2: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="Address line 2"
                                            type="text"
                                            name="address2"
                                        />
                                    );
                                case 'city':
                                    return (
                                        <TextField
                                            key={field.name}
                                            required={field.required}
                                            value={form.city || ''}
                                            onChange={event => setForm({ ...form, city: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="City"
                                            type="text"
                                            name="city"
                                        />
                                    );
                                case 'county':
                                    return (
                                        <TextField
                                            key={field.name}
                                            required={field.required}
                                            value={form.county || ''}
                                            onChange={event => setForm({ ...form, county: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="County"
                                            type="text"
                                            name="county"
                                        />
                                    );
                                case 'country':
                                    return (
                                        <SimpleCountriesInput
                                            key={field.name}
                                            name="country"
                                            value={form.country}
                                            onChange={value => setForm({ ...form, country: value })}
                                            required={field.required}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            labelOffset={8}
                                        />
                                    );
                                case 'postal':
                                    return (
                                        <TextField
                                            key={field.name}
                                            required={field.required}
                                            value={form.postal || ''}
                                            onChange={event => setForm({ ...form, postal: event.target.value })}
                                            className={`${classes.inputMargin} ${classes.input}`}
                                            fullWidth
                                            variant="outlined"
                                            label="Postcode"
                                            type="text"
                                            name="postal"
                                        />
                                    );
                                default:
                                    return '';
                            }
                        })}

                        <Box mt={4} display="flex" justifyContent="center">
                            <Button type="submit" className={[classes.button, classes.pinkButton]}>
                                {isLoading ? 'Loading...' : 'Sign Up'}
                            </Button>
                        </Box>
                    </form>
                )}
            </div>
        );
    };

    const checkboxes = () => (
        <div>
            <Box display={'flex'} alignItems="center">
                <Checkbox
                    checked={signupMethod === signupMethodsConstant.FIRST_TIME}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                    onClick={() => setSignupMethod(signupMethodsConstant.FIRST_TIME)}
                />
                <Typography>I am new to {organisation.name} (creates a new client account)</Typography>
            </Box>
            <Box display={'flex'} alignItems="center">
                <Checkbox
                    checked={signupMethod === signupMethodsConstant.EXISTING_CUSTOMER}
                    color="primary"
                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                    onClick={() => setSignupMethod(signupMethodsConstant.EXISTING_CUSTOMER)}
                />
                <Typography>I am an existing {organisation.name} customer</Typography>
            </Box>
        </div>
    );

    const loginForm = () => (
        <form onSubmit={handleLogin} autoComplete="on">
            <TextField
                value={form.email || ''}
                onChange={event => setForm({ ...form, email: event.target.value })}
                fullWidth
                className={classes.inputMargin}
                variant="outlined"
                label="Email"
                type="email"
                name="email"
                autoComplete="email"
            />

            <FormControl className={classes.passwordField} variant="outlined" fullWidth>
                <InputLabel htmlFor="password">Password</InputLabel>
                <OutlinedInput
                    id="password"
                    value={form.password || ''}
                    variant="outlined"
                    type={showPassword ? 'text' : 'password'}
                    onChange={event => setForm({ ...form, password: event.target.value })}
                    name="password"
                    autoComplete="current-password"
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword(prev => !prev)}>
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>

            <Box mt={2}>
                <a href="/forgot-password" target="_blank" className={classes.linkColor}>
                    Forgot Password
                </a>
            </Box>

            <Box mt={2} display="flex" justifyContent="space-between">
                <Button type="submit" disabled={isLoading} className={[classes.button, classes.blueButton]}>
                    {isLoading ? 'Loading...' : 'Log In'}
                </Button>
                <Button onClick={handleRegister} className={[classes.button, classes.pinkButton]}>
                    {isLoading ? 'Loading...' : 'Sign Up'}
                </Button>
            </Box>
        </form>
    );

    return (
        <Dialog
            open={!!modalVisibility.visible}
            // className={classes.container}
            disableBackdropClick={currentStepState.currentStep === 'confirm' || modalVisibility.blockClose}
            onClose={handleClose}
            disableEscapeKeyDown={currentStepState.currentStep === 'confirm'}
        >
            {isLogin && accountCreated && (
                <Typography className={classes.accountCreated}>
                    Your account has been created. Please check your inbox (and junk mail) to verify your email before
                    logging in.
                </Typography>
            )}
            <DialogTitle className={classes.title}>
                {!isLogin && (
                    <div
                        className={classes.backButton}
                        onClick={() => {
                            setDisplayInfo({
                                canDisplay: false,
                                text: '',
                                displayRed: false
                            });
                            setIsLogin(true);
                            setSignupMethod(undefined);
                        }}
                    >
                        <ArrowBackIos />
                        Back
                    </div>
                )}
                {isLogin && 'Log in / sign up to continue'}
            </DialogTitle>
            <DialogContent>
                {isLogin ? loginForm() : signupForm()}

                {displayInfo.canDisplay && (
                    <Box className={classes.infoBox}>
                        <Typography className={[classes.info, displayInfo.displayRed && classes.fontRed]}>
                            {displayInfo.text}
                        </Typography>
                    </Box>
                )}

                {isLoading && <CircularProgress />}
            </DialogContent>
        </Dialog>
    );
};

export default LoginModal;
